var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-bar"},[_c('p',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.formatPercentageFinanced(_vm.object))+" financiado\n  ")]),_vm._v(" "),_c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress-bar"},[_c('span',{staticClass:"bar",style:(("width: " + (_vm.object.funded_percentage) + "%"))})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-543360af","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBar.vue
// module id = null
// module chunks = 